import { render } from "./VPAAStaffRepLoad.vue?vue&type=template&id=3debb014"
import script from "./VPAAStaffRepLoad.vue?vue&type=script&lang=js"
export * from "./VPAAStaffRepLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__